import { Loader } from "processhub-components-lib";
import AllDynamicWidgets from "pages/Dashboard/AllDynamicWidgets";
import allHooks from "hooks";
import { FiCheck, FiPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import classNames from "utilities/ClassNames";
import useApp from "hooks/useApp";
import { usePins } from "hooks/usePins";
import { TitleInit, TitleInputInit, editTitleInit } from "./config/constants";
import { cn } from "@/lib/utils";
import PinnedWidgets from "components/PinnedWidgets/PinnedWidgets";

export default function NewDashboard() {
  const {
    updateDashboardWidgets,
    dashboardWidgets,
    dashboardWidgetsLoading,
  } = useApp();

  const { unpinAllWidgets, loading } = usePins();
  const [titles, setTitles] = useState<any>(TitleInit);
  const [editTitle, setEditTitle] = useState(editTitleInit);
  const [titleInput, setTitleInput] = useState(TitleInputInit);
  const [unpinConfirmation, setUnpinConfirmation] = useState(false);

  useEffect(() => {
    const temptitles = [...titles];
    const widgetTitles = [
      dashboardWidgets.title1,
      dashboardWidgets.title2,
      dashboardWidgets.title3,
    ];
    widgetTitles.map((item: any, index: any) => {
      if (item && item !== "") {
        temptitles[index] = { ...temptitles[index], title: item };
      }
    });

    setTitles(temptitles);
  }, [dashboardWidgets]);

  if (dashboardWidgetsLoading) {
    return (
      <div className="w-full h-[80vh] grid place-content-center">
        <Loader />
      </div>
    );
  }

  const handleTitleChanges = (
    index: any,
    newValue: any,
    item: any,
    setitem: any
  ) => {
    const updatedTitleInputs = [...item];
    updatedTitleInputs[index] = {
      ...updatedTitleInputs[index],
      title: newValue,
    };
    setitem(updatedTitleInputs);
  };

  return (
    <div
      className={classNames(
        "overflow-y-scroll xl:overflow-y-hidden", "flex-row-reverse pb-3 w-full h-full overflow-hidden flex relative"
      )}
    >
      {dashboardWidgets.selectedType !== "init" && (
        <div
          className={classNames(
            "lg:min-w-[260px]  2xl:min-w-[260px] flex flex-wrap justify-between items-baseline relative",
            "w-[17%]"
          )}
        >
          <PinnedWidgets hooks={allHooks} />
          <div className="flex items-end justify-end h-max w-full absolute bottom-10 2xl:bottom-5 right-4">
            {!unpinConfirmation && <button className="btn-danger" onClick={() => setUnpinConfirmation(true)}>Unpin All Tags</button>}
            {unpinConfirmation &&
              <div className="flex gap-5">
                <button className="btn-sec" onClick={() => setUnpinConfirmation(false)}>Keep</button>
                <button className="btn-danger" onClick={() => {
                  unpinAllWidgets(1);
                  setUnpinConfirmation(false);
                }}>Remove</button>
              </div>}
          </div>
        </div>
      )}
      <div
        className={classNames(
          dashboardWidgets.selectedType === "init" ? "w-full" : "w-[83%]"
        )}
      >
        <AllDynamicWidgets type={dashboardWidgets.selectedType} />
      </div>
    </div>
  );
}
